/**
 * Reinterpret a *local* calendar-day Date — as emitted by the design-system
 * `Calendar` / react-day-picker, which produce local midnight for the clicked
 * day — as UTC midnight of that same calendar day.
 *
 * The Service booking pipeline represents a booking date as UTC midnight (see
 * `getDateString`, `Summary.setUTCHours`, `timeZone:'UTC'`), so the day
 * the user clicks must be normalised this way to avoid an off-by-one for users
 * east of UTC. Reads integer Y/M/D components, so it is DST-immune.
 */
export default (d: Date): Date =>
  new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
